export default function init() {
    document.querySelectorAll('.attachment-widget').forEach(widget => {

        const uploadZone = widget.querySelector('.attachment-widget__upload');
        const replaceBtn = widget.querySelector('.attachment-widget__replace-trigger');
        const fileInput = widget.querySelector('input[type="file"]');
        const selectedFile = widget.querySelector('.attachment-widget__selected-file');

        if (!replaceBtn || !uploadZone || !fileInput) {
            return;
        }
        replaceBtn.addEventListener('click', () => {
            const replacing = uploadZone.hidden;
            console.log("Etat de l'uploadzone :" + (uploadZone.hidden ? 'caché' : 'visible'))
            if (replacing) {
                console.log("replacing")
                uploadZone.hidden = false;
                replaceBtn.textContent = 'Annuler le remplacement';
            } else {
                console.log("not replacing")
                uploadZone.hidden = true;
                replaceBtn.textContent = 'Remplacer le fichier';

                fileInput.value = '';

                if (selectedFile) {
                    selectedFile.textContent = '';
                }
            }
        });

        fileInput.addEventListener('change', () => {

            if (!selectedFile) {
                return;
            }

            if (fileInput.files.length > 0) {
                selectedFile.textContent =
                    `Nouveau fichier sélectionné : ${fileInput.files[0].name}`;
            } else {
                selectedFile.textContent = '';
            }
        });
    });
}
